import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  IProcurementSubmission,
  IProcurementSubmissionItems,
  IProcurementSubmissions,
} from 'types/submissions'
import { submissionApi } from './submissions'
import { IdParams } from 'types/api'

export const procurementSubmissionApi = createApi({
  reducerPath: 'procurementSubmissions',
  baseQuery,
  tagTypes: ['ProcurementSubmissions', 'ProcurementSubmissionsItems'],
  endpoints: (builder) => ({
    createProcurementSubmission: builder.mutation<
      void,
      Partial<IProcurementSubmission>
    >({
      query: (body) => ({
        url: `/procurement-submissions`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['ProcurementSubmissionsItems'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(submissionApi.util.invalidateTags(['Submission']))
      },
    }),
    procurementSubmissions: builder.query<IProcurementSubmissions, IdParams>({
      query: (params) => ({
        url: `/procurement-submissions/${params.id}`,
        params,
      }),
      providesTags: ['ProcurementSubmissions'],
    }),
    procurementSubmissionsItems: builder.query<
      IProcurementSubmissionItems,
      IdParams
    >({
      query: (params) => ({
        url: `/procurement-submissions/${params.id}/items`,
        params,
      }),
      providesTags: ['ProcurementSubmissionsItems'],
    }),
  }),
})

export const {
  useCreateProcurementSubmissionMutation,
  useProcurementSubmissionsItemsQuery,
  useProcurementSubmissionsQuery
} = procurementSubmissionApi
